<template>
  <nav id="nav-menu" class="fixed-bottom py-0 d-flex justify-content-around mt-2">
    <div :style="mtdGetStyle('box')" 
      class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border" 
      @click="mtdSendOption('box')"><span :style="mtdGetStyleSpan('box')" class="btn w-100">
      <strong>CAJA</strong></span>
    </div>
    <div :style="mtdGetStyle('gestionPacientes')" 
      class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border" 
      @click="mtdSendOption('gestionPacientes')"><span :style="mtdGetStyleSpan('gestionPacientes')" class="btn w-100">
      <strong>GESTION DE PACIENTES</strong></span>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'FooterGerenciaComponent',
  props: {
    pageView: String
  },
  data () {
    return {
      page: null
    }
  },
  created () {
   
  },
  methods: {
    mtdGetStyle:function(option){
      if (option == this.page && this.pageView != "home" && this.pageView != "venta" && this.pageView != "close") return 'background: #2f395c';
      return '';
    },
    mtdGetStyleSpan:function(option){
      if (option == this.page && this.pageView != "home" && this.pageView != "venta" && this.pageView != "close") return 'color:white';
      return '';
    },
    mtdSendOption: function(page){
      this.page=page;
      this.$emit('mtdChangePage',this.page)
    }
  },
}
</script>